import { PanelType } from "@fluentui/react";

import { PanelGenerico } from "../../components/generic/PanelGenerico";
import BaseTelelirk from "../../components/generic/baseTelerik";
import themeBase from "../../utils/theme/themeBase";

interface Idsp{
    isOpen:boolean|undefined
    onDismiss: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void) | undefined
}

function ReporteHistoricoChecklist(props:Idsp) {

    return (
        <>
        <PanelGenerico
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                enabledFooter={true}
                panelType={PanelType.large}
                enabledHeader={true}
                HeaderTitlesText={{title:"Reporte Histórico Checklist"}}
            >
                <div style={themeBase._padding20}>
                    <BaseTelelirk reportName="ChecklistReporteHistorico.trdx" parametros={{}} />
                </div>
            </PanelGenerico>
        </>
    );
}

export default ReporteHistoricoChecklist;